import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const AppointmentMovement: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={3}>Дата назначения</Typography>
                    <Typography mb={1} ml={11}>Отделение</Typography>
                    <Typography mb={1} ml={16}>Должность</Typography>
                    <Typography mb={1} ml={11}>Дата перемещения</Typography>
                    <Typography mb={1} ml={10}>Вид работы </Typography>
                    <Typography mb={1} ml={9}>№ внутреннего совмес-ва</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "200px", mr: 1, mb: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={1}>Отделение:</Typography>
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={1}>Должность:</Typography>
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={1}>Специальность:</Typography>
                </Box>
            </Body>
        </Box>
    );
};

export default AppointmentMovement;

